module.exports = "pegasus/assets/blocks/image-5-tech.png";